import OBase from './OBase';

import * as Geometry from '../geometry';

export default class Range extends OBase {
  update () {
    var dValTree = this.getIntervalObjectInput('Domain');
    var sValTree = this.getFloatInput('Steps');

    var output = this.getGenericObjectOutput('Range');

    var dataTrees = [];
    var outDataTrees = [];
    dataTrees.push(dValTree);
    dataTrees.push(sValTree);

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    var outTree = new Geometry.DataTree();
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        var path = new Geometry.GHPath(outDataTrees[0].paths[i]);
        path.add(j);

        var intervalVal = outDataTrees[0].branches[i][j];
        var stepVal = outDataTrees[1].branches[i][j];

        for (let t = 0; t <= stepVal; t++) {
          let val = intervalVal.min + (intervalVal.max - intervalVal.min) / stepVal * t;
          outTree.add(val, path);
        }
      }
    }

    output.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Range.js